import { ProgressBar } from "react-bootstrap";
import React from "react";

const getScooterProgressBar = (condition, children = null) => {
  let className = "";
  // eslint-disable-next-line no-restricted-globals
  if (condition && !isNaN(parseFloat(condition.percent))) {
    const { percent } = condition;
    if (percent > 70) {
      className = "success";
    } else if (percent < 20) {
      className = "danger";
    } else {
      className = "primary";
    }

    return (
      <div className="position-relative w-100" style={{
        height: 20
      }}>
        <div
          className="w-100 h-100  position-absolute text-center"
          style={{
            color: "#fff",
            textShadow: "1px 1px 2px #000",
            lineHeight: 1
          }}
        >
          {percent}% {children}
        </div>
        <ProgressBar
          animated
          variant={className}
          now={percent}
          className="border"
        />
      </div>
    );
  }
  return false;
};

export default getScooterProgressBar;



// WEBPACK FOOTER //
// ./src/helpers/scooter/get-scooter-progress-bar.js